
import axios from "axios";
import { BASE_URL } from "./config";
import {
  getToken,
  getRefreshToken,
  saveTokens,
  clearAuth,
  getTokenExpiry,
  setTokenExpiry,
} from "./services/useAuth";
import { getJwtExpiry } from "./utils/jwt";

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

let refreshPromise = null;
let refreshTimer = null;

const isAuthRoute = (url = "") =>
  url.includes("/api/login") || url.includes("/api/refresh-token");

const scheduleRefresh = () => {
  if (refreshTimer) clearTimeout(refreshTimer);

  const expiry = getTokenExpiry();
  if (!expiry) return;
  const now = Date.now();
  
  
  const delay = expiry - Date.now() - 5000;
  if (delay <= 0) {
    refreshToken();
    return;
  }

  refreshTimer = setTimeout(refreshToken, delay);
};

const refreshToken = async () => {
  if (refreshPromise) return refreshPromise;

  const refresh = getRefreshToken();
  if (!refresh) throw new Error("No refresh token");

  refreshPromise = axios
    .post(`${BASE_URL}/api/refresh-token`, { refresh_token: refresh })
    .then(res => {
      const { access_token, refresh_token } = res.data;
      const expiry = getJwtExpiry(access_token);

      saveTokens({ access_token, refresh_token });
      setTokenExpiry(expiry);
      scheduleRefresh();

      return access_token;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};
api.interceptors.request.use(async (config) => {
  if (!isAuthRoute(config.url)) {
    const expiry = getTokenExpiry();
    if (expiry && expiry <= Date.now()) {
      try {
        const newToken = await refreshToken();
        config.headers.Authorization = `Bearer ${newToken}`;
        return config;
      } catch (err) {
        clearAuth();
        window.location.href = "/login";
        return Promise.reject(err);
      }
    }

    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});


/* RESPONSE */
api.interceptors.response.use(
  res => res,
  async (error) => {
    const original = error.config;

    if (isAuthRoute(original?.url)) {
      return Promise.reject(error);
    }

 if (error.response?.status === 401 && !original._retry) {
  original._retry = true;
  try {
    const newToken = await refreshToken();
    original.headers.Authorization = `Bearer ${newToken}`;
    return api(original);
  } catch (err) {
    clearAuth();
    window.location.href = "/login";
    return Promise.reject(err);
  }
}

    return Promise.reject(error);
  }
);

export const initializeTokenRefresh = () => {
  const expiry = getTokenExpiry();
  if (expiry && expiry > Date.now()) {
    scheduleRefresh();
  }
};

export default api;
